// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/Prev-Button.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/Next-Button.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-demo .product-item .product-item-content {
  border-radius: 3px;
  margin: 0.3rem;
  text-align: center;
  padding: 0.2rem 0;
}

.carousel-demo .product-item .product-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin: 0 auto;
}

.p-carousel-items-container {
  flex-wrap: wrap;
  display: flex;
}

.p-carousel-indicators {
  display: none;
}

.carousel-demo .card {
  background: #ffffff;
  border-radius: 20px;
  border: solid 1px #dee0e1;
  padding: 15px;
}

.p-carousel .p-carousel-content .p-carousel-prev,
.p-carousel .p-carousel-content .p-carousel-next {
  width: 1.5rem;
  height: 1.5rem;
}

.slick-slider {
  border: solid 1px #dee0e1;
  padding: 26px 20px 2px 20px;
  border-radius: 20px;
  background-color: #ffffff !important;
}

.slick-arrow {
  width: 20px;
  height: 20px;
}

.slick-arrow::before {
  content: " ";
}

.slick-prev,
.slick-prev:hover,
.slick-prev:focus {
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) right center no-repeat;
}

.slick-next,
.slick-next:hover,
.slick-next:focus {
  right: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) left center no-repeat;
}

.product-item-content {
  position: relative;
}

.hover-Box {
  display: none;
  position: absolute;
  top: 0;
  right: 0;
  background-color: white;
  width: auto;
  height: auto;
  padding: 10px;
  font-size: 14px;
  color: black;
  z-index: 2;
  border-radius: 12px solid red ;
  overflow:visible;

}

.product-item-content:hover .hover-Box {
  display: block;
}

.hover-Box p {
  margin: 0 0 8px; /* Adjust spacing between paragraphs */
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/CarouselDemo.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,OAAO;EACP,0EAAoE;AACtE;;AAEA;;;EAGE,QAAQ;EACR,yEAAmE;AACrE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,YAAY;EACZ,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;;AAElB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe,EAAE,sCAAsC;AACzD","sourcesContent":[".carousel-demo .product-item .product-item-content {\r\n  border-radius: 3px;\r\n  margin: 0.3rem;\r\n  text-align: center;\r\n  padding: 0.2rem 0;\r\n}\r\n\r\n.carousel-demo .product-item .product-image {\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 50%;\r\n  margin: 0 auto;\r\n}\r\n\r\n.p-carousel-items-container {\r\n  flex-wrap: wrap;\r\n  display: flex;\r\n}\r\n\r\n.p-carousel-indicators {\r\n  display: none;\r\n}\r\n\r\n.carousel-demo .card {\r\n  background: #ffffff;\r\n  border-radius: 20px;\r\n  border: solid 1px #dee0e1;\r\n  padding: 15px;\r\n}\r\n\r\n.p-carousel .p-carousel-content .p-carousel-prev,\r\n.p-carousel .p-carousel-content .p-carousel-next {\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n}\r\n\r\n.slick-slider {\r\n  border: solid 1px #dee0e1;\r\n  padding: 26px 20px 2px 20px;\r\n  border-radius: 20px;\r\n  background-color: #ffffff !important;\r\n}\r\n\r\n.slick-arrow {\r\n  width: 20px;\r\n  height: 20px;\r\n}\r\n\r\n.slick-arrow::before {\r\n  content: \" \";\r\n}\r\n\r\n.slick-prev,\r\n.slick-prev:hover,\r\n.slick-prev:focus {\r\n  left: 0;\r\n  background: url(../../images/Prev-Button.svg) right center no-repeat;\r\n}\r\n\r\n.slick-next,\r\n.slick-next:hover,\r\n.slick-next:focus {\r\n  right: 0;\r\n  background: url(../../images/Next-Button.svg) left center no-repeat;\r\n}\r\n\r\n.product-item-content {\r\n  position: relative;\r\n}\r\n\r\n.hover-Box {\r\n  display: none;\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  background-color: white;\r\n  width: auto;\r\n  height: auto;\r\n  padding: 10px;\r\n  font-size: 14px;\r\n  color: black;\r\n  z-index: 2;\r\n  border-radius: 12px solid red ;\r\n  overflow:visible;\r\n\r\n}\r\n\r\n.product-item-content:hover .hover-Box {\r\n  display: block;\r\n}\r\n\r\n.hover-Box p {\r\n  margin: 0 0 8px; /* Adjust spacing between paragraphs */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
